import { BankLoginUrlDto, BankError } from '#modules/Bank/Bank.types'

type BankLoginClearStateAction = { type: 'BANK_LOGIN_CLEAR_STATE' }
type BankLoginClearErrorsAction = { type: 'BANK_LOGIN_CLEAR_ERRORS' }
type CreateBankLoginUrlAction = {
	type: 'CREATE_BANK_LOGIN_URL'
	bankId: number
	ssn?: string
}
type CreateBankLoginUrlSucceededAction = {
	type: 'CREATE_BANK_LOGIN_URL_SUCCEEDED'
	bankLoginUrlDto: BankLoginUrlDto
}
type CreateBankLoginUrlFailedAction = {
	type: 'CREATE_BANK_LOGIN_URL_FAILED'
	createBankLoginError: BankError
}

export type BankLoginAction =
	| BankLoginClearStateAction
	| BankLoginClearErrorsAction
	| CreateBankLoginUrlAction
	| CreateBankLoginUrlSucceededAction
	| CreateBankLoginUrlFailedAction

export function clearState(): BankLoginClearStateAction {
	return {
		type: 'BANK_LOGIN_CLEAR_STATE',
	}
}

export function clearErrors(): BankLoginClearErrorsAction {
	return {
		type: 'BANK_LOGIN_CLEAR_ERRORS',
	}
}

export function createBankLoginUrl(
	monthioInternalBankId: number,
	ssn?: string,
): CreateBankLoginUrlAction {
	return {
		type: 'CREATE_BANK_LOGIN_URL',
		bankId: monthioInternalBankId,
		ssn,
	}
}

export function createBankLoginUrlSucceeded(
	bankLoginUrlDto: BankLoginUrlDto,
): CreateBankLoginUrlSucceededAction {
	return {
		type: 'CREATE_BANK_LOGIN_URL_SUCCEEDED',
		bankLoginUrlDto,
	}
}

export function createBankLoginUrlFailed(
	createBankLoginError: BankError,
): CreateBankLoginUrlFailedAction {
	return {
		type: 'CREATE_BANK_LOGIN_URL_FAILED',
		createBankLoginError,
	}
}
